import axios from "axios";
import React, { useEffect, useState } from "react";
import BASE_URL from "../Config";

const HeaderForSporRegistration = () => {
  const [eventData, setEventData] = useState(null);

  const getPayment = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getMasterEvent`);
      const data = response.data?.data?.[0]; // Assuming it's the first event
      console.log("Success:", data);
      setEventData(data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    getPayment();
  }, []);

  if (!eventData) return null; // Avoid rendering until data is fetched

  // Format event date range
  const startDate = new Date(eventData.start_date);
  const endDate = new Date(eventData.end_date);
  const formatOptions = { year: "numeric", month: "long", day: "2-digit" };
  const eventDateRange = `${startDate.toLocaleDateString(
    "en-US",
    formatOptions
  )} - ${endDate.toLocaleDateString("en-US", formatOptions)}`;

  return (
    <div>
      <div id="page" className="page">
        <div className="inner-page-wrapper">
          <section
            className="hero-section"
            style={{
              backgroundImage: `url(https://event.sopa.org/public/images/event/${eventData.banner})`,
              position: "relative",
            }}
          >
            <div className="container">
              <div className="row d-flex align-items-center">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="hero-3-txt text-center white-color">
                    <h2
                      className="oxygen-font-900 event-title"
                      style={{ textTransform: "uppercase" }}
                    >
                      Delegate Reservation
                    </h2>
                    <h5
                      className="oxygen-font-900 mb-3 event-sub-title"
                      style={{ textTransform: "uppercase" }}
                    >
                      {eventData?.sub_title}
                    </h5>
                    <div
                      className="date_location"
                      style={{ flexDirection: "column" }}
                    >
                      <div className="event_date">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 27 30"
                        >
                          <path
                            id="Icon_material-date-range"
                            data-name="Icon material-date-range"
                            d="M13.5,16.5h-3v3h3Zm6,0h-3v3h3Zm6,0h-3v3h3ZM28.5,6H27V3H24V6H12V3H9V6H7.5A2.986,2.986,0,0,0,4.515,9L4.5,30a3,3,0,0,0,3,3h21a3.009,3.009,0,0,0,3-3V9A3.009,3.009,0,0,0,28.5,6Zm0,24H7.5V13.5h21Z"
                            transform="translate(-4.5 -3)"
                            fill="#f8c400"
                          />
                        </svg>
                        <span>{eventDateRange}</span>
                      </div>
                      <div className="event_location">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20.25 29.25"
                        >
                          <path
                            id="Icon_ionic-ios-pin"
                            data-name="Icon ionic-ios-pin"
                            d="M18,3.375c-5.59,0-10.125,4.212-10.125,9.4C7.875,20.088,18,32.625,18,32.625S28.125,20.088,28.125,12.776C28.125,7.587,23.59,3.375,18,3.375ZM18,16.8a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,18,16.8Z"
                            transform="translate(-7.875 -3.375)"
                            fill="#f8c400"
                          />
                        </svg>
                        <span>{eventData?.event_address} </span>
                        {/* Make this dynamic if address is also part of API */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HeaderForSporRegistration;
